import React from 'react';
import PropTypes from 'prop-types';
import debug from 'debug';
import {Row, Column, DescriptiveText} from '../../../shared';
import Insight from './Insight';

const log = debug('circleblack:investor:components:insights:Featured');

const Featured = ({showHeading, articles, height}) => {
  log('rendering');

  const createInsight = (article, width, isRecent) => (
    <Insight
      article={article}
      width={width}
      fontSize={'18px'}
      font={'ProximaSemibold'}
      isRecent={isRecent}
      layout={{grow: 1}}
    />
  );

  let recents = null;

  if (articles.length === 3) {
    recents = (
      <Row height={'fill'} width={'25%'} justifySubColumn={'middle'}>
        {showHeading && <DescriptiveText
          margin={'10px'}
          fontSize={'18px'}
          font={'ProximaSemibold'}
          alignment={'left'}
        >
          Recents
        </DescriptiveText>}
        <Column showDividers={true}>
          {createInsight(articles[1], 'fill', true)}
          {createInsight(articles[2], 'fill', true)}
        </Column>
      </Row>
    );
  }

  return <Row margin={'20px 0 30px 0'} height={height} showDividers={true}>
    <Column height={'fill'} width={(articles.length === 2) ? null : '70%'}>
      {showHeading && <DescriptiveText
        margin={'10px 10px 10px 0'}
        fontSize={'18px'}
        font={'ProximaSemibold'}
        alignment={'left'}
      >
        Featured
      </DescriptiveText>}
      <Row height={'fill'} showDividers={true}>
        {createInsight(articles[0], 'fill')}
        {(articles.length === 2) && createInsight(articles[1], 'fill')}
      </Row>
    </Column>
    {recents}
  </Row>;
};

export default Featured;

Featured.propTypes = {
  /**
   * if true, Featured/Recents headings are displayed
   */
  showHeading: PropTypes.bool,
  /**
   * the Insight articles to display
   */
  articles: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    distributionDate: PropTypes.string.isRequired,
  })).isRequired,
  /**
   * height
   */
  height: PropTypes.string,
  /**
   * size
   */
  size: PropTypes.object,
};
